import { Model } from 'sunlife-domain'

import { isDeselectUpdate, isSelectUpdate } from '@salsita-ai/platform-project-sdk/domain'

import { configuratorInterface } from '../systems/configurator-interface'

export const focusOnLiner = configuratorInterface.transformerBuilder.when
  .entity(Model.Shorts.types)
  .modified({ atFields: ['liner'] })
  .and(ctx => ctx.update.updateTag !== 'ensureLinerForTanThrough')
  .then.changeView('FocusOnLiner')
  .else(
    configuratorInterface.transformerBuilder.when
      .entity(Model.AnyDomainEntity.types)
      .modified()
      .then.changeView('Default')
      .build('unFocusOnLinerOnAny')
  )
  .build('focusOnLiner')

export const unFocusOnSelection = configuratorInterface.transformerBuilder.when
  .update(['modifyEphemeralRecord'])
  .fired.and(ctx => isDeselectUpdate(ctx.update) || isSelectUpdate(ctx.update))
  .then.changeView('Default')
  .build('unFocusOnSelection')
